<template>
	<v-container fluid class="fill-height">
		<v-row align="center" justify="center">
			<v-col cols="12" sm="8" md="6">
				<v-card class="elevation-12">
					<v-card-title class="display-1 deep-orange white--text">
						Sitio en mantenimiento
						</v-card-title>
					<v-card-text>
						<v-row align="center" justify="center">
							<v-col cols="12" sm="4" class="text-center">
								<v-icon size="100" color="deep-orange">fas fa-tools</v-icon>
							</v-col>
							<v-col cols="12" sm="8">
								<p class="text-center">Actualmente estamos ejecutando tareas de mantenimiento en el sitio, pedimos disculpas por las molestias ocasionadas y le invitamos a ingresar nuevamente en unos minutos. </p>
								<p class="body-1 text-center">Para mayor información puede escribirnos un correo a <a :href="href" class="deep-orange--text">losandescoworking@gmail.com</a> o por el numero de teléfono <strong>0424-2192367</strong>.</p>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	export default {
		name: 'mantenimiento',
		created(){
			let cual = this.$route.params.num
			this.sitio = this.$sitios[cual-1]
		},
		data () {
			return {
				sitio:null,
				sitios: ['Los Andes Coworking', 'Sam Coworking','Margarita Coworking','VIMORCA']
			}
		},
		computed: {
			href: function () {
				let string = 'mailto:losandescoworking@gmail.com?subject='

				let encondeSubject = encodeURI('[Tech] Información del sitio '+this.sitio)

				return string+encondeSubject
			}
		}
	}
</script>